<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import GlobalAppNotification from '@/client/components/_organisms/global_app_notification'
import api from '@/client/core/api'
import SessionError from '@/client/core/session_error'
import NavBar from '@/client/features/navbar/NavBar.vue'
import { useSystemStore } from '@/client/store/useSystemStore'

interface Data {
  intervalId?: ReturnType<typeof setInterval>
}

export default defineComponent({
  components: {
    GlobalAppNotification,
    NavBar
  },
  data(): Data {
    return {
      intervalId: undefined
    }
  },
  computed: {
    ...mapState(useSystemStore, ['loading', 'emergencyNotification'])
  },
  methods: {
    ...mapActions(useSystemStore, ['closeEmergencyNotification']),
    async checkSession(): Promise<void> {
      const result = await api.get<{ expired: boolean }>('/me/session')

      if (result.expired) SessionError.showNotify()
    }
  },
  mounted() {
    this.intervalId = setInterval(() => {
      this.checkSession().catch(console.error)
    }, 60 * 1000)
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  }
})
</script>

<template>
  <div>
    <GlobalAppNotification
      v-if="emergencyNotification"
      :notification="emergencyNotification"
      @close="closeEmergencyNotification"
    />
    <NavBar />
    <div v-if="loading" class="loading-bar" />
    <div v-else class="loading-bar-hide" />
    <div class="page-content">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.page-content {
  max-width: $max-content-width;
  margin: 16px auto;
}
</style>
